import React from 'react'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'
import UIkit from 'uikit'

// Components
import CountdownTimer from 'app/views/components/CountdownTimer'
import ModalQuizTimeRanOut from 'app/views/components/Modals/ModalQuizTimeRanOut'
import QuizBrowserLoader from 'app/views/components/QuizBrowserLoader'

// Containers
import BrowserEditorArea from 'app/views/containers/BrowserEditorArea'

// Redux
import {
  replReset,
} from 'app/state/modules/repl'
import {
  getQuizById,
  getQuizStep,
  postQuizAnswer,
} from 'app/state/modules/quiz'

// Utils
import analytics from 'app/views/utils/analytics'
import isMobileDevice from 'app/views/utils/mobile'


class QuizStep extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      answer: '',
      debounceLoading: false,
    }

    this.handleClickSubmitAnswer = this.handleClickSubmitAnswer.bind(this)
    this.handleOnSubmitClick = this.handleOnSubmitClick.bind(this)
    this.handleAnswerChange = this.handleAnswerChange.bind(this)
    this.handleOnStartNextQuestion = this.handleOnStartNextQuestion.bind(this)
    this.handleReset = this.handleReset.bind(this)
  }

  componentDidMount() {
    analytics.page('quiz-step')

    // If the quiz hasn't been defined, the user has probably refreshed the page, so we need to
    // re-retrieve the quiz details
    if (this.props.quiz.quiz.uuid === '') {
      this.props.getQuizById(this.props.match.params.id)
    } else {
      this.props.getQuizStep(
        this.props.match.params.id,
        this.props.quiz.quiz.questions[this.props.quiz.currentQuestion].uuid,
      )
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // This means the component just received a new quiz uuid (probably because the user refreshed
    // the page and the quiz details needed to be re-retrieved)
    if (this.props.quiz.quiz.uuid === '' && nextProps.quiz.quiz.uuid !== '') {
      this.props.getQuizStep(
        this.props.match.params.id,
        nextProps.quiz.quiz.questions[this.props.quiz.currentQuestion].uuid,
      )
    }

    if (Object.keys(nextProps.question).length === 0) {
      this.props.history.push(`/quiz/${this.props.quiz.quiz.uuid}/survey`)
    }
  }

  handleClickSubmitAnswer() {
    this.props.postQuizAnswer(
      this.props.quiz.quiz.uuid,
      this.props.question.uuid,
      this.state.answer,
      null,
      null,
    )
    this.props.replReset()
    this.setState({ answer: null })
  }

  handleOnSubmitClick(code) {
    this.setState({
      debounceLoading: true,
    }, () => {
      setTimeout(() => {
        this.props.postQuizAnswer(
          this.props.quiz.quiz.uuid,
          this.props.question.uuid,
          null,
          code,
          this.props.engine,
        )
        this.props.replReset()
        this.setState({ answer: null })
        setTimeout(() => { this.setState({ debounceLoading: false }) }, 1500)
      }, 500)
    })
  }

  handleAnswerChange(e) {
    this.setState({
      answer: e.target.value,
    })
  }

  handleOnStartNextQuestion() {
    this.handleOnSubmitClick('')
    UIkit.modal('#modal-quiz-time-ran-out').hide()
  }

  handleReset() {
    this.setState({
      resetDisabled: true,
    }, () => {
      setTimeout(() => {
        this.setState({ resetDisabled: false })
      }, 5000)
      if (this.state.resetDisabled === true) {
        this.browserEditorArea.handleSandboxReset()
      }
    })
  }

  render() {
    if (this.props.question.time_remaining === 0) {
      this.handleOnSubmitClick('')
    }

    if (isMobileDevice()) {
      return (
        <div className="uk-section">
          <div className="uk-container uk-text-center">
            <h3 className="uk-text-bold">Looks like you are on mobile...</h3>
            <p>
              Thanks for checking out our Secure Coding IQ Assessment while on the go, but our tools
              are not available on mobile.
            </p>
            <Link className="uk-button uk-button-primary" to="/">Back To Homepage</Link>
          </div>
        </div>
      )
    }
    return (
      <div>
        <div className="uk-cover-container uk-background-secondary uk-padding-large uk-padding-remove-bottom uk-padding-remove-top uk-light">
          <div className="uk-section uk-padding-remove">
            <div className="uk-text-center">
              <h2>{this.props.question.question}</h2>
              <h4 className="uk-margin-remove-top">
                {this.props.question.description}
                &nbsp;
              </h4>
            </div>
            <CountdownTimer
              className="uk-position-right uk-padding-small"
              time={this.props.question.time_remaining}
              id={this.props.question.uuid}
              onComplete={() => { UIkit.modal('#modal-quiz-time-ran-out').show() }}
            />
          </div>
        </div>

        {(this.props.question.type === 'sandbox') ? (
          <div className="uk-cover-container">
            {(this.state.debounceLoading || this.props.proxyStatus === 'init' || this.props.proxyStatus === 'reset') && <QuizBrowserLoader
              resetDisabled={this.state.resetDisabled}
              handleReset={this.props.handleReset}
            />}
            <BrowserEditorArea
              onRef={(ref) => { this.browserEditorArea = ref }}
              hasTest={false}
              handleClickBack={(stepId) => { this.handleClickBack(stepId) }}
              handleClickCircle={(stepId) => { this.handleClickCircle(stepId) }}
              handleClickNext={(stepId) => { this.handleClickNext(stepId) }}
              handleClickDone={(stepId) => { this.handleClickDone(stepId) }}
              onSubmitClick={(code) => { this.handleOnSubmitClick(code) }}
              steps={[]}
              hints={[]}
              name="name"
              ecsTaskDefinition={this.props.question.metadata.ecs_task}
              lessonCompletionURL="/register"
              lessonCompletionText="Create an Account"
            />
          </div>
        ) : (
            <div>
              {(this.props.question.type === 'multiple_choice' && this.props.question.metadata.answers.length > 0) && (
                <div className="uk-cover-container">
                  <div className="uk-container">
                    <div className="uk-section uk-margin-medium-bottom uk-padding-large uk-text-center">
                      <div className="uk-flex uk-flex-center">
                        <form>
                          <fieldset className="uk-fieldset">
                            <table className="uk-text-left">
                              <tbody>
                                {this.props.question.metadata.answers.map((answer, i) => (
                                  <tr key={answer}>
                                    <td>
                                      <input
                                        className="uk-radio"
                                        type="radio"
                                        name="answer"
                                        checked={(this.state.answer === i.toString())}
                                        value={i}
                                        onChange={this.handleAnswerChange}
                                      />
                                    </td>
                                    <td>
                                      {answer}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </fieldset>
                          <Link
                            to="#"
                            className="uk-button uk-button-primary uk-button-large tm-button-primary tm-button-large"
                            onClick={this.handleClickSubmitAnswer}
                          >
                            Submit Answer
                        </Link>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )
        }
        <ModalQuizTimeRanOut id="modal-quiz-time-ran-out" onStartNextQuestion={this.handleOnStartNextQuestion} />
      </div >
    )
  }
}

const mapStateToProps = state => ({
  quiz: state.quiz,
  question: state.quiz.question,
  questions: state.quiz.quiz.questions,
  currentQuestion: state.quiz.currentQuestion,
  engine: state.repl.engine,
  proxyStatus: state.proxy.status
})

const mapDispatchToProps = dispatch => ({
  replReset: () => { dispatch(replReset()) },
  getQuizById: (quizId) => { dispatch(getQuizById(quizId)) },
  getQuizStep: (quizId, questionId) => { dispatch(getQuizStep(quizId, questionId)) },
  postQuizAnswer: (quizId, questionId, answer, code, engine) => {
    dispatch(postQuizAnswer(quizId, questionId, answer, code, engine))
  },
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(QuizStep))
